<div class="form-section-v2" [hidden]="this.frmGroup.get(this.configData.name)['hidden']">
    <div class="section-header" style="display: grid;grid-template-columns: 2fr 1fr">
        <div>{{configData.label}}</div>
        <div *ngIf="configData.groupLevelAction" class="group-level-action">
            <app-additional-information-v2 [additionalInfo]="configData.groupLevelAction" [configData] ="configData"></app-additional-information-v2>
        </div>
    </div>
    <main>
    <span *ngIf="configData.displayInTableFormat">
        <div class="my-flex-container">
            <div class="my-flex-row" *ngFor="let row of getFormTableControls(); let rowIndex = index">
                <ng-container *ngFor="let control of configData.controls; let colIndex = index">
                    <div class="my-flex-cell" *ngIf="control?.mainHeader">
                        <div class="td-content-wrapper">
                            <div class="lable-width">{{ control?.mainHeader }} :</div>
                                <app-form-field id="{{configData.name}}" [configData]="control"
                                    [frmGroup]="getFormTableControls()[rowIndex]" [ngClass]="getColsClass(control)"
                                    [class.hide]="getFormTableControls()[rowIndex].get(control.name)?.hidden && control.component !=='SPACEHOLDER_V2' && control.colsHidden">
                                </app-form-field>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </span>
    <div *ngIf="!configData.displayInTableFormat">
        <div class="row" *ngFor="let row of getFormTableControls(); let rowIndex = index">
            <app-form-field id="{{configData.name}}" *ngFor="let control of configData.controls" [configData]="control"
            [frmGroup]="getFormTableControls()[rowIndex]" [ngClass]="getColsClass(control)" 
            [class.hide]="getFormTableControls()[rowIndex].get(control.name)?.hidden && control.component !=='SPACEHOLDER_V2' && control.colsHidden"> 
            </app-form-field>  
        </div>
        </div>
    </main>
    <footer *ngIf="!configData.hideSectionLine">
        <div class="section-footer"></div>
    </footer>
</div>